import React, { useEffect, useContext } from "react";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";

// Context
import FirebaseContext from '../context/FirebaseContext'

// Componentes
import Home from "../components/Home";
import About from "../components/about/About";
import Portfolio from "../components/Portfolio";
import Contact from "../components/Contact";

const HomeLight = () => {

    const { fetchCategories, fetchApps } = useContext( FirebaseContext )

    useEffect(() => {
        
        document.body.classList.add("dark");
        fetchCategories()
        fetchApps()
        
    // eslint-disable-next-line
    }, [])

    return (
        <>
            <Tabs>
                <TabList>

                    <div className="leftpart">
                        <div className="leftpart_inner">
                            <div className="logo">
                                    
                                <p className = "custom-title">
                                    Fronted Developer
                                </p>

                            </div>

                            <div className="menu">
                                <ul>
                                    <Tab>
                                        <img
                                            className="svg"
                                            src="/assets/img/svg/home-run.svg"
                                            alt="homerun"
                                        />
                                        <span className="menu_content">Home</span>
                                    </Tab>
                                    <Tab>
                                        <img
                                            className="svg"
                                            src="/assets/img/svg/avatar.svg"
                                            alt="avatar"
                                        />
                                        <span className="menu_content">About</span>
                                    </Tab>
                                    <Tab>
                                        <img
                                            className="svg"
                                            src="/assets/img/svg/briefcase.svg"
                                            alt="briefcase"
                                        />
                                        <span className="menu_content">Portfolio</span>
                                    </Tab>
                                    <Tab>
                                        <img
                                            className="svg"
                                            src="/assets/img/svg/mail.svg"
                                            alt="mail"
                                        />
                                        <span className="menu_content"> Contact</span>
                                    </Tab>
                                </ul>
                            </div>

                            <div className="copyright">
                                <p>
                                    
                                    &copy; {new Date().getFullYear()} Alpha <br /> 
                                    
                                </p>
                            </div>
                        </div>
                    </div>
                    
                </TabList>

                <div className="rightpart">
                    <div className="rightpart_in">
                        <div className="tokyo_tm_section">
                            <div className="container">
                                
                                <TabPanel>

                                    <Home />

                                </TabPanel>

                                <TabPanel>

                                    <About />

                                </TabPanel>

                                <TabPanel>

                                    <Portfolio />

                                </TabPanel>

                                <TabPanel>

                                    <Contact />

                                </TabPanel>

                            </div>
                        </div>
                    </div>
                </div>

            </Tabs>
        </>
    );
};

export default HomeLight;
